import { Component } from '@angular/core';
import { LoaderService } from 'src/services/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  isLoading$ = this.loaderService.isLoading$;
  title = 'Staff UI';

  constructor(private loaderService: LoaderService) {}
}
